document.addEventListener('DOMContentLoaded', function () {

  var currWidth = window.innerWidth;

  window.addEventListener('resize', function () {
    if (window.innerWidth <= 992) {
      currWidth = window.innerWidth;
    }
    if (window.innerWidth > currWidth && window.innerWidth > 992) {
      document.location.reload();
      currWidth = window.innerWidth;
    }
  }, true);
});